import { generatePath } from 'react-router-dom'

const generateRoute = route => {
  return params => (params ? generatePath(route, params) : route)
}

export const PARAM_ENTITY = {
  ORGANIZATION: ':organizationId',
  USER: ':userId',
  PLATFORM: ':platformId',
  DISPLAY: ':displayId',
  ORDER: ':orderId',
  JOB: ':jobId',
  JOBTYPE: ':jobTypeId',
  OFFERTYPE: ':offerTypeId',
  TASK: ':taskId',
  TASKTYPE: ':taskTypeId',
  PRODUCT: ':productId',
  VISUAL: ':visualId',
  STAGE_TEMPLATE: ':stageTemplateId',
  SHARE: ':shareId',
  GEOMETRY: ':geometryId',
  LOCATION_CODE: ':locationCode',
  PROJECT: ':projectId',
  BATCH: ':batchId',
  JOURNEY: ':journey',
  PROJECT_TYPE: ':projectType',
  BRIEF_ORDER: ':briefOrderId',
  PACKAGE_EXPECTATION: ':packageExpectationId',
  PACKAGE_REQUIREMENT: ':packageRequirementId',
  PACKAGE_GUIDELINE: ':packageGuidelineId',
  PACKAGE_SECTION: ':packageSection',
  EXPECTATION: ':expectationId',
  DRAFT_PRODUCT: ':draftProductId',
  AUDIT: ':auditId',
  VISUAL_GAP_SCOPE: ':visualGapScopeId',
  VISUAL_CLASS: ':visualClassId',
  VQA_CHECK: ':vqaCheckId',
}

const ROOT_GLOBAL = 'g'
const ROOT_INTERNAL = 'i'

export const GLOBAL = generateRoute(`/settings/${ROOT_GLOBAL}`)
export const INTERNAL = generateRoute(`/${ROOT_INTERNAL}`)

export const ORGANIZATION_DETAILS_TABS = {
  USERS: 'users',
  SHARE: 'share',
  ABOUT: 'about',
  DASHBOARD: 'dashboard',
  PREFERENCES: 'preferences',
  API_TOKEN: 'api-token',
  RELATIONSHIP: 'relationship',
}

export const ORGANIZATION_USER_DETAILS_TABS = {
  ABOUT: 'about',
  MANAGE: 'manage',
  CERTIFICATE: 'certificate',
}

export const STAGE_TEMPLATE_DETAILS_TABS = {
  PREVIEW: 'preview',
  SCENE: 'ambiance',
  INFINITE: 'infinite',
  ABOUT: 'about',
  PRODUCTS: 'products',
  LOCATIONS: 'locations',
}

export const ORDER_DETAILS_TABS = {
  OVERVIEW: 'overview',
  TASK: 'task',
  ACTORS: 'actors',
  ABOUT: 'about',
  DELIVERY: 'delivery',
  PDPPACKAGE: 'pdp-package',
}

export const PROJECTS_BATCH_JOURNEY = {
  MODELING: 'modeling',
  PDPPACKAGE: 'pdp-package',
}

export const ADMINISTRATION_TABS = {
  ORGANIZATION: 'organization',
  SHARES: 'shares',
  DASHBOARD: 'dashboard',
  USERS: 'users',
  VISUALS_PROPERTIES: 'visuals-properties',
  WORKFLOWS: 'workflows',
}

export const GLOBAL_SHARES_TABS = {
  ACTIVE: 'active',
  STOPPED: 'rejected-or-stopped',
}

export const TASK_DETAILS_TABS = {
  ABOUT: 'about',
  HISTORY: 'history',
  OUTPUTS: 'outputs',
}

export const PHOTOGRAPH_TABS = {
  PACKSHOT: 'packshot',
  SCENE: 'ambiance',
  INSPIRATION: 'inspiration',
}

export const PRODUCT_DETAILS_TABS = {
  ASSET3D: 'digital-twin',
  PACKSHOT: 'packshot',
  SCENE: 'ambiance',
  INFINITE: 'infinite',
  ABOUT: 'about',
  ORDERS: 'orders',
  REFERENCE_IMAGES: 'reference-images',
  AUDITED_VISUALS: 'audited-visuals',
  VISUALS: 'visuals',
}

export const PLATFORM_DETAILS_TABS = {
  DISPLAY: 'display',
  ABOUT: 'about',
}

export const INFINITE_DETAILS_TABS = {
  CREATE: 'create',
  PRODUCT: 'product',
  ABOUT: 'about',
}

export const VISUAL_DETAILS_TABS = {
  DOWNLOAD: 'download',
  PRODUCT: 'product',
  PUBLISH: 'publish',
  ABOUT: 'about',
  DECOR: 'decor',
  ACTOR: 'actor',
}

export const MY_ACTIVITIES_TABS = {
  ORDERS: 'order',
}

function generateOptionalParamEntity(paramEntity) {
  return `${paramEntity}?`
}

/**************************************************************************************
 **************************************************************************************
 ******************* PUBLIC ROUTES
 **************************************************************************************
 **************************************************************************************/

export const CONNECTION = generateRoute('/connection')
export const LOGIN = generateRoute('/connection/login')
export const RESET_PASSWORD = generateRoute('/connection/reset-password')
export const RESET_PASSWORD_CONFIRMATION = generateRoute('/connection/reset-password/confirmation')
export const RESET_PASSWORD_UPDATE = generateRoute('/connection/reset-password/update')
export const RESET_PASSWORD_FIRST_CONNECTION = generateRoute('/connection/reset-password/first-connection')

/**************************************************************************************
 **************************************************************************************
 ******************* COMMON ROUTES
 **************************************************************************************
 **************************************************************************************/

export const HOME = generateRoute('/')
export const HOME_SCENE_DETAILS = generateRoute(`/ambiance/${PARAM_ENTITY.VISUAL}`)
export const HOME_SCENE_DETAILS_DOWNLOAD = generateRoute(
  `/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const HOME_SCENE_DETAILS_PUBLISH = generateRoute(
  `/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const HOME_SCENE_DETAILS_PRODUCT = generateRoute(
  `/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const HOME_SCENE_DETAILS_DECOR = generateRoute(`/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DECOR}`)
export const HOME_SCENE_DETAILS_ABOUT = generateRoute(`/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`)
export const HOME_SCENE_DETAILS_ACTOR = generateRoute(`/ambiance/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ACTOR}`)
export const HOME_PACKSHOT_DETAILS = generateRoute(`/packshot/${PARAM_ENTITY.VISUAL}`)
export const HOME_PACKSHOT_DETAILS_DOWNLOAD = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const HOME_PACKSHOT_DETAILS_PUBLISH = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const HOME_PACKSHOT_DETAILS_PRODUCT = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const HOME_PACKSHOT_DETAILS_DECOR = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DECOR}`,
)
export const HOME_PACKSHOT_DETAILS_ABOUT = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`,
)
export const HOME_PACKSHOT_DETAILS_ACTOR = generateRoute(
  `/packshot/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ACTOR}`,
)

/**************************************************************************************
 **************************************************************************************
 ******************* INTERNAL ROUTES
 **************************************************************************************
 **************************************************************************************/

export const INTERNAL_PLAYGROUND_PERMISSIONS = generateRoute(`${INTERNAL()}/permissions`)
export const INTERNAL_APPLICATION_INFOS = generateRoute(`${INTERNAL()}/infos`)
export const INTERNAL_DL_3D = generateRoute(`${INTERNAL()}/3d-dl`)
export const INTERNAL_DL_LAYERS = generateRoute(`${INTERNAL()}/layers-dl`)
export const INTERNAL_PICTURE = generateRoute(`${INTERNAL()}/picture`)

/**************************************************************************************
 **************************************************************************************
 ******************* GLOBAL ROUTES
 **************************************************************************************
 **************************************************************************************/

/****************** DASHBOARD *************/

export const ORGANIZATION_GLOBAL_DASHBOARD = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.DASHBOARD}`)

/****************** SETTINGS *************/

export const SETTINGS = generateRoute('/settings')

/****************** MY ACTIVITIES *************/

export const MY_ACTIVITIES = generateRoute('/my-activities')

/****************** PROFILE *************/

export const PROFILE = generateRoute(`${SETTINGS()}/profile`)
export const PROFILE_ABOUT = generateRoute(`${PROFILE()}/about`)
export const PROFILE_PREFERENCES = generateRoute(`${PROFILE()}/preferences`)
export const PROFILE_PASSWORD = generateRoute(`${PROFILE()}/password`)
export const PROFILE_CERTIFICATE = generateRoute(`${PROFILE()}/certificate`)

/****************** ORGANIZATION |-> ORGANIZATION_USER *************/

export const ORGANIZATION_GLOBAL = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}`)
export const ORGANIZATION_GLOBAL_CREATE = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/create`)
export const ORGANIZATION_GLOBAL_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_ABOUT = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.ABOUT}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_SHARES = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.SHARE}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_SHARES_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.SHARE}/${
    PARAM_ENTITY.SHARE
  }`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_ADD_USER = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${
    ORGANIZATION_DETAILS_TABS.USERS
  }/add-user`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_ADD_USER_SERVICE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${
    ORGANIZATION_DETAILS_TABS.USERS
  }/add-user-service`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_ADD_API_TOKEN = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${
    ORGANIZATION_DETAILS_TABS.API_TOKEN
  }/add-api-token`,
)
/** Same page/modal split as the settings route, for the Platform Administration side. */
export const ORGANIZATION_GLOBAL_USER_PAGE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/user/${PARAM_ENTITY.USER}`,
)

export const ORGANIZATION_GLOBAL_DETAILS_USERS_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}/${
    PARAM_ENTITY.USER
  }`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_DETAILS_ABOUT = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}/${
    PARAM_ENTITY.USER
  }/${ORGANIZATION_USER_DETAILS_TABS.ABOUT}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_DETAILS_MANAGE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}/${
    PARAM_ENTITY.USER
  }/${ORGANIZATION_USER_DETAILS_TABS.MANAGE}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_DETAILS_CERTIFICATE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}/${
    PARAM_ENTITY.USER
  }/${ORGANIZATION_USER_DETAILS_TABS.CERTIFICATE}`,
)
export const ORGANIZATION_GLOBAL_DETAILS_USERS_DETAILS_CERTIFICATE_ADD_CERTIFICATE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.USERS}/${
    PARAM_ENTITY.USER
  }/${ORGANIZATION_USER_DETAILS_TABS.CERTIFICATE}/add-certificate`,
)
export const ORGANIZATION_GLOBAL_DETAILS_PREFERENCES = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${
    ORGANIZATION_DETAILS_TABS.PREFERENCES
  }`,
)
export const ORGANIZATION_GLOBAL_API_TOKEN = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.ORGANIZATION}/${PARAM_ENTITY.ORGANIZATION}/${ORGANIZATION_DETAILS_TABS.API_TOKEN}`,
)

/****************** SHARES *************/

export const ORGANIZATION_GLOBAL_SHARES = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}`)

export const ORGANIZATION_GLOBAL_SHARES_CREATE = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}/create`)
export const ORGANIZATION_GLOBAL_SHARES_ACTIVE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}/${GLOBAL_SHARES_TABS.ACTIVE}`,
)

export const ORGANIZATION_GLOBAL_SHARES_STOPPED = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}/${GLOBAL_SHARES_TABS.STOPPED}`,
)
export const ORGANIZATION_GLOBAL_SHARES_ACTIVE_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}/${GLOBAL_SHARES_TABS.ACTIVE}/${PARAM_ENTITY.SHARE}`,
)
export const ORGANIZATION_GLOBAL_SHARES_STOPPED_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.SHARES}/${GLOBAL_SHARES_TABS.STOPPED}/${PARAM_ENTITY.SHARE}`,
)

/****************** VISUALS PROPERTIES *************/

export const ORGANIZATION_GLOBAL_VISUALS_PROPERTIES = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.VISUALS_PROPERTIES}`,
)
export const ORGANIZATION_GLOBAL_VISUALS_PROPERTIES_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.VISUALS_PROPERTIES}/${PARAM_ENTITY.VISUAL_CLASS}`,
)

export const VISUALS_PROPERTIES_TABS = {
  VQA_CHECKS: 'vqa-checks',
}

export const ORGANIZATION_GLOBAL_VISUALS_PROPERTIES_VQA = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.VISUALS_PROPERTIES}/${VISUALS_PROPERTIES_TABS.VQA_CHECKS}`,
)
export const ORGANIZATION_GLOBAL_VISUALS_PROPERTIES_VQA_CREATE = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.VISUALS_PROPERTIES}/${VISUALS_PROPERTIES_TABS.VQA_CHECKS}/create`,
)
export const ORGANIZATION_GLOBAL_VISUALS_PROPERTIES_VQA_DETAILS = generateRoute(
  `${GLOBAL()}/${ADMINISTRATION_TABS.VISUALS_PROPERTIES}/${VISUALS_PROPERTIES_TABS.VQA_CHECKS}/${PARAM_ENTITY.VQA_CHECK}`,
)

/****************** WORKFLOWS *************/

export const WORKFLOWS_SECTION = {
  OFFER_TYPES: 'offer-types',
  JOB_TYPES: 'job-types',
  TASK_TYPES: 'task-types',
  MINI_APPS: 'mini-apps',
}

export const ORGANIZATION_GLOBAL_WORKFLOWS = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.WORKFLOWS}`)

export const ORGANIZATION_GLOBAL_WORKFLOWS_OFFER_TYPES = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS()}/${WORKFLOWS_SECTION.OFFER_TYPES}`,
)

export const ORGANIZATION_GLOBAL_WORKFLOWS_OFFER_TYPE_DETAILS = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS_OFFER_TYPES()}/${PARAM_ENTITY.OFFERTYPE}`,
)

export const ORGANIZATION_GLOBAL_WORKFLOWS_JOB_TYPES = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS()}/${WORKFLOWS_SECTION.JOB_TYPES}`,
)

export const ORGANIZATION_GLOBAL_WORKFLOWS_JOB_TYPE_DETAILS = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS_JOB_TYPES()}/${PARAM_ENTITY.JOBTYPE}`,
)

export const ORGANIZATION_GLOBAL_WORKFLOWS_TASK_TYPES = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS()}/${WORKFLOWS_SECTION.TASK_TYPES}`,
)

export const ORGANIZATION_GLOBAL_WORKFLOWS_TASK_TYPE_DETAILS = generateRoute(
  `${ORGANIZATION_GLOBAL_WORKFLOWS_TASK_TYPES()}/${PARAM_ENTITY.TASKTYPE}`,
)

/****************** USERS *************/

export const ORGANIZATION_GLOBAL_USERS = generateRoute(`${GLOBAL()}/${ADMINISTRATION_TABS.USERS}`)

/**************************************************************************************
 **************************************************************************************
 ******************* ORGANIZATION ROUTES
 **************************************************************************************
 **************************************************************************************/

/****************** ORGANIZATION |-> ORGANIZATION_USER *************/

export const ORGANIZATION = generateRoute(`${SETTINGS()}/organization`)
export const ORGANIZATION_ABOUT = generateRoute(`${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.ABOUT}`)
export const ORGANIZATION_SHARES = generateRoute(`${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.SHARE}`)
export const ORGANIZATION_SHARES_DETAILS = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.SHARE}/${PARAM_ENTITY.SHARE}`,
)
export const ORGANIZATION_USERS = generateRoute(`${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}`)
export const ORGANIZATION_USERS_ADD_USER = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/add-user`,
)
export const ORGANIZATION_USERS_ADD_USER_SERVICE = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/add-user-service`,
)

export const ORGANIZATION_USERS_API_TOKEN = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.API_TOKEN}`,
)
export const ORGANIZATION_USERS_ADD_API_TOKEN = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.API_TOKEN}/add-api-token`,
)

/**
 * The user rendered as a page rather than as the modal the list opens, mirroring how a product has
 * both `/product/product-preview/:id` (modal) and `/product/:id` (page). Lives outside the users tab
 * so the list does not render behind it.
 */
export const ORGANIZATION_USER_PAGE = generateRoute(`${SETTINGS()}/organization/user/${PARAM_ENTITY.USER}`)

export const ORGANIZATION_USERS_DETAILS = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/${PARAM_ENTITY.USER}`,
)
export const ORGANIZATION_USERS_DETAILS_ABOUT = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/${PARAM_ENTITY.USER}/${
    ORGANIZATION_USER_DETAILS_TABS.ABOUT
  }`,
)
export const ORGANIZATION_USERS_DETAILS_MANAGE = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/${PARAM_ENTITY.USER}/${
    ORGANIZATION_USER_DETAILS_TABS.MANAGE
  }`,
)
export const ORGANIZATION_USERS_DETAILS_CERTIFICATE = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/${PARAM_ENTITY.USER}/${
    ORGANIZATION_USER_DETAILS_TABS.CERTIFICATE
  }`,
)
export const ORGANIZATION_USERS_DETAILS_CERTIFICATE_ADD_CERTIFICATE = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.USERS}/${PARAM_ENTITY.USER}/${
    ORGANIZATION_USER_DETAILS_TABS.CERTIFICATE
  }/add-certificate`,
)
export const ORGANIZATION_DASHBOARD = generateRoute(`${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.DASHBOARD}`)
export const ORGANIZATION_PREFERENCES = generateRoute(
  `${SETTINGS()}/organization/${ORGANIZATION_DETAILS_TABS.PREFERENCES}`,
)

/****************** PLATFORM |-> DISPLAY *************/

export const PLATFORM = generateRoute('/platform')
export const PLATFORM_CREATE = generateRoute('/platform/create')
export const PLATFORM_DETAILS = generateRoute(`/platform/${PARAM_ENTITY.PLATFORM}`)
export const PLATFORM_DETAILS_ABOUT = generateRoute(`/platform/${PARAM_ENTITY.PLATFORM}/${PLATFORM_DETAILS_TABS.ABOUT}`)
export const PLATFORM_DETAILS_DISPLAY = generateRoute(
  `/platform/${PARAM_ENTITY.PLATFORM}/${PLATFORM_DETAILS_TABS.DISPLAY}`,
)
export const PLATFORM_DETAILS_DISPLAY_CREATE = generateRoute(
  `/platform/${PARAM_ENTITY.PLATFORM}/${PLATFORM_DETAILS_TABS.DISPLAY}/create`,
)
export const PLATFORM_DETAILS_DISPLAY_DETAILS = generateRoute(
  `/platform/${PARAM_ENTITY.PLATFORM}/${PLATFORM_DETAILS_TABS.DISPLAY}/${PARAM_ENTITY.DISPLAY}`,
)

export const PLATFORM_INFINITE_DETAILS = generateRoute(
  `/platform/${PARAM_ENTITY.PLATFORM}?/${PLATFORM_DETAILS_TABS.DISPLAY}/infinite/${PARAM_ENTITY.DISPLAY}`,
)
export const PLATFORM_INFINITE_DETAILS_CREATE = generateRoute(
  `/platform/${PLATFORM_DETAILS_TABS.DISPLAY}/${PARAM_ENTITY.DISPLAY}/${INFINITE_DETAILS_TABS.CREATE}`,
)
export const PLATFORM_INFINITE_DETAILS_ABOUT = generateRoute(
  `/platform/${PLATFORM_DETAILS_TABS.DISPLAY}/${PARAM_ENTITY.DISPLAY}/${INFINITE_DETAILS_TABS.ABOUT}`,
)
export const PLATFORM_INFINITE_DETAILS_PRODUCT = generateRoute(
  `/platform/${PLATFORM_DETAILS_TABS.DISPLAY}/${PARAM_ENTITY.DISPLAY}/${INFINITE_DETAILS_TABS.PRODUCT}`,
)

/****************** ORDER |-> JOB |-> TASK *************/

export const ORDER = generateRoute(`${MY_ACTIVITIES()}/${MY_ACTIVITIES_TABS.ORDERS}`)
export const ORDER_DETAILS = generateRoute(`${ORDER()}/${PARAM_ENTITY.ORDER}`)
export const ORDER_SCENE_DETAILS = generateRoute(`${ORDER()}/ambiance/${PARAM_ENTITY.VISUAL}`)
export const ORDER_PACKSHOT_DETAILS = generateRoute(`${ORDER()}/packshot/${PARAM_ENTITY.VISUAL}`)
export const ORDER_DETAILS_JOB_DETAILS = generateRoute(`${ORDER()}/${PARAM_ENTITY.ORDER}/job/${PARAM_ENTITY.JOB}`)

// order tabs
// route that matches tab
export const ORDER_DETAILS_JOB_DETAILS_TABS = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/:tab(${Object.values(ORDER_DETAILS_TABS).join('|')})?`,
)

export const ORDER_DETAILS_JOB_DETAILS_PDP_PACKAGE = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.PDPPACKAGE}`,
)
export const ORDER_DETAILS_JOB_DETAILS_OVERVIEW = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.OVERVIEW}`,
)
export const ORDER_DETAILS_JOB_DETAILS_DELIVERY = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.DELIVERY}`,
)
export const ORDER_DETAILS_JOB_DETAILS_TASK = generateRoute(`${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.TASK}`)
export const ORDER_DETAILS_JOB_DETAILS_ACTORS = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.ACTORS}`,
)
export const ORDER_DETAILS_JOB_DETAILS_ABOUT = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS()}/${ORDER_DETAILS_TABS.ABOUT}`,
)

// order delivery modals
export const ORDER_DETAILS_JOB_DETAILS_DELIVERY_AMBIANCE = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS_DELIVERY()}/ambiance/${PARAM_ENTITY.VISUAL}`,
)
export const ORDER_DETAILS_JOB_DETAILS_DELIVERY_PACKSHOT = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS_DELIVERY()}/packshot/${PARAM_ENTITY.VISUAL}`,
)
export const ORDER_DETAILS_JOB_DETAILS_DELIVERY_INFINITE = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS_DELIVERY()}/infinite/${PARAM_ENTITY.DISPLAY}`,
)

// order overview modal
export const ORDER_DETAILS_JOB_DETAILS_OVERVIEW_TASK_DETAILS = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS_OVERVIEW()}/task/${PARAM_ENTITY.TASK}`,
)

// order task modal
export const ORDER_DETAILS_JOB_DETAILS_TASK_DETAILS = generateRoute(
  `${ORDER_DETAILS_JOB_DETAILS_TASK()}/${PARAM_ENTITY.TASK}`,
)

// miniapp & report
export const ORDER_DETAILS_JOB_DETAILS_TASK_DETAILS_MINIAPP = generateRoute(
  `${ORDER()}/${PARAM_ENTITY.ORDER}/job/${PARAM_ENTITY.JOB}/${ORDER_DETAILS_TABS.TASK}/${PARAM_ENTITY.TASK}/miniapp`,
)
export const ORDER_DETAILS_JOB_DETAILS_TASK_DETAILS_MINIAPP_IMAGE_GENERATOR = generateRoute(
  `${ORDER()}/${PARAM_ENTITY.ORDER}/${ORDER_DETAILS_TABS.TASK}/${generateOptionalParamEntity(
    PARAM_ENTITY.TASK,
  )}/miniapp-image-generator`,
)
export const ORDER_DETAILS_JOB_DETAILS_TASK_DETAILS_REPORT = generateRoute(
  `${ORDER()}/${PARAM_ENTITY.ORDER}/job/${PARAM_ENTITY.JOB}/${ORDER_DETAILS_TABS.TASK}/${generateOptionalParamEntity(
    PARAM_ENTITY.TASK,
  )}/report`,
)

/****************** PRODUCT |-> INFINITE, VISUAL  *************/

export const PRODUCT = generateRoute('/product')

export const PRODUCT_DETAILS = generateRoute(`/product/${PARAM_ENTITY.PRODUCT}`)

export const PRODUCT_DETAILS_DIGITAL_TWIN_GEOMETRY_DETAILS = generateRoute(
  `/product/${PARAM_ENTITY.PRODUCT}/${PRODUCT_DETAILS_TABS.ASSET3D}/geometry/${PARAM_ENTITY.GEOMETRY}`,
)

export const PRODUCT_DETAILS_VISUALS = generateRoute(`/product/${PARAM_ENTITY.PRODUCT}/${PRODUCT_DETAILS_TABS.VISUALS}`)
export const PRODUCT_DETAILS_VISUALS_SCENE_DETAILS = generateRoute(
  `/product/${PARAM_ENTITY.PRODUCT}/${PRODUCT_DETAILS_TABS.VISUALS}/${PRODUCT_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}`,
)
export const PRODUCT_DETAILS_VISUALS_PACKSHOT_DETAILS = generateRoute(
  `/product/${PARAM_ENTITY.PRODUCT}/${PRODUCT_DETAILS_TABS.VISUALS}/${PRODUCT_DETAILS_TABS.PACKSHOT}/${PARAM_ENTITY.VISUAL}`,
)

/****************** DRAFT CATALOG ****************/
export const DRAFT_CATALOG = generateRoute('/draft-catalog')

export const ORG_DRAFT_CATALOG = generateRoute(`/draft-catalog/${PARAM_ENTITY.ORGANIZATION}`)

/****************** VISUALS |-> SCENES, PACKSHOTS *************/

export const VISUALS = generateRoute('/photograph')

export const VISUALS_PACKSHOT_DETAILS = generateRoute(`/photograph/${PHOTOGRAPH_TABS.PACKSHOT}/${PARAM_ENTITY.VISUAL}`)
export const VISUALS_PACKSHOT_DETAILS_CREATE = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.PACKSHOT}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const VISUALS_PACKSHOT_DETAILS_PRODUCT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.PACKSHOT}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const VISUALS_PACKSHOT_DETAILS_ABOUT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.PACKSHOT}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`,
)

export const VISUALS_SCENE_DETAILS = generateRoute(`/photograph/${PHOTOGRAPH_TABS.SCENE}/${PARAM_ENTITY.VISUAL}`)
export const VISUALS_SCENE_DETAILS_DOWNLOAD = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const VISUALS_SCENE_DETAILS_PUBLISH = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const VISUALS_SCENE_DETAILS_PRODUCT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const VISUALS_SCENE_DETAILS_ABOUT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`,
)

//TODO: remove this if we are not going to use inspirations anymore
export const VISUALS_INSPIRATION = generateRoute(`/photograph/${PHOTOGRAPH_TABS.INSPIRATION}`)
export const VISUALS_INSPIRATION_DETAILS = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.INSPIRATION}/${PARAM_ENTITY.VISUAL}`,
)
export const VISUALS_INSPIRATION_DETAILS_DOWNLOAD = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.INSPIRATION}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const VISUALS_INSPIRATION_DETAILS_PUBLISH = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.INSPIRATION}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const VISUALS_INSPIRATION_DETAILS_PRODUCT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.INSPIRATION}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const VISUALS_INSPIRATION_DETAILS_ABOUT = generateRoute(
  `/photograph/${PHOTOGRAPH_TABS.INSPIRATION}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`,
)

/****************** PHOTO ART DIRECTION |-> STAGE TEMPLATES  *************/

export const PHOTO_ART_DIRECTION = generateRoute('/photo-art-direction')
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE = generateRoute('/photo-art-direction/decor')
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_PREVIEW = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.PREVIEW}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE_DETAILS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE_DETAILS_DOWNLOAD = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE_DETAILS_PUBLISH = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE_DETAILS_PRODUCT = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_SCENE_DETAILS_ABOUT = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.SCENE}/${PARAM_ENTITY.VISUAL}/${VISUAL_DETAILS_TABS.ABOUT}`,
)

export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE_DETAILS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}/${PARAM_ENTITY.DISPLAY}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE_DETAILS_DOWNLOAD = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}/${PARAM_ENTITY.DISPLAY}/${VISUAL_DETAILS_TABS.DOWNLOAD}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE_DETAILS_PUBLISH = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}/${PARAM_ENTITY.DISPLAY}/${VISUAL_DETAILS_TABS.PUBLISH}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE_DETAILS_PRODUCT = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}/${PARAM_ENTITY.DISPLAY}/${VISUAL_DETAILS_TABS.PRODUCT}`,
)
export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_INFINITE_DETAILS_ABOUT = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.INFINITE}/${PARAM_ENTITY.DISPLAY}/${VISUAL_DETAILS_TABS.ABOUT}`,
)

export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_ABOUT = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.ABOUT}`,
)

export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_LOCATIONS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.LOCATIONS}`,
)

export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_LOCATIONS_DETAILS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.LOCATIONS}/${PARAM_ENTITY.LOCATION_CODE}`,
)

export const PHOTO_ART_DIRECTION_STAGE_TEMPLATE_DETAILS_PRODUCTS = generateRoute(
  `/photo-art-direction/decor/${PARAM_ENTITY.STAGE_TEMPLATE}/${STAGE_TEMPLATE_DETAILS_TABS.PRODUCTS}`,
)

/****************** PROVIDERS *************/

export const PROVIDERS = generateRoute(`/providers`)

/****************** CATEGORIES *************/

export const CATEGORIES = generateRoute(`/categories`)

/****************** PROJECTS *************/

export const PROJECTS = generateRoute(`/projects`)
export const PROJECTS_CREATE = generateRoute(`${PROJECTS()}/create/${PARAM_ENTITY.PROJECT_TYPE}`)
export const PROJECT_DETAILS = generateRoute(`${PROJECTS()}/${PARAM_ENTITY.PROJECT}`)

export const PROJECT_DETAILS_JOURNEY = generateRoute(`${PROJECT_DETAILS()}/${PARAM_ENTITY.JOURNEY}`)
export const PROJECT_DETAILS_BATCH_DETAILS = generateRoute(
  `${PROJECT_DETAILS()}/batch/${PARAM_ENTITY.BATCH}/${PARAM_ENTITY.JOURNEY}`,
)

export const PROJECT_DETAILS_BATCH_DETAILS_MINIAPP = generateRoute(
  `${PROJECT_DETAILS_BATCH_DETAILS()}/miniapp/${PARAM_ENTITY.ORDER}/task/${PARAM_ENTITY.TASK}`,
)

/****************** RULES AND PACKAGES *************/

export const RULES_AND_PACKAGES_SECTION = {
  PACKAGE_EXPECTATIONS_GENAI: 'package-expectations',
  PACKAGE_EXPECTATIONS_PDP: 'package-expectations-pdp',
  PACKAGE_REQUIREMENTS: 'package-requirements',
  PACKAGE_GUIDELINES: 'package-guidelines',
  NAMING_CONVENTIONS: 'naming-conventions',
}

export const RULES_PACKAGES = generateRoute('/rules-packages')

export const RULES_PACKAGES_DETAILS = generateRoute(`${RULES_PACKAGES()}/${PARAM_ENTITY.ORGANIZATION}`)

/****************** MANAGE ENDPOINTS *************/

export const MANAGE_ENDPOINTS = generateRoute('/manage-endpoints')

/****************** AUTOMATION *************/

export const PACKAGE_EXPECTATIONS = generateRoute(
  `${RULES_PACKAGES_DETAILS()}/${RULES_AND_PACKAGES_SECTION.PACKAGE_EXPECTATIONS_GENAI}`,
)

export const PACKAGE_EXPECTATIONS_CREATE = generateRoute(`${PACKAGE_EXPECTATIONS()}/create`)

export const PACKAGE_EXPECTATIONS_DETAILS = generateRoute(
  `${PACKAGE_EXPECTATIONS()}/${PARAM_ENTITY.PACKAGE_EXPECTATION}`,
)

export const PACKAGE_EXPECTATIONS_DETAILS_EXPECTATION_DETAILS = generateRoute(
  `${PACKAGE_EXPECTATIONS_DETAILS()}/expectation/${PARAM_ENTITY.EXPECTATION}`,
)

export const PACKAGE_EXPECTATIONS_PDP = generateRoute(
  `${RULES_PACKAGES_DETAILS()}/${RULES_AND_PACKAGES_SECTION.PACKAGE_EXPECTATIONS_PDP}`,
)

export const PACKAGE_EXPECTATIONS_PDP_DETAILS = generateRoute(
  `${PACKAGE_EXPECTATIONS_PDP()}/${PARAM_ENTITY.PACKAGE_EXPECTATION}`,
)

export const PACKAGE_REQUIREMENTS = generateRoute(
  `${RULES_PACKAGES_DETAILS()}/${RULES_AND_PACKAGES_SECTION.PACKAGE_REQUIREMENTS}`,
)

export const PACKAGE_REQUIREMENTS_DETAILS = generateRoute(
  `${PACKAGE_REQUIREMENTS()}/${PARAM_ENTITY.PACKAGE_REQUIREMENT}`,
)

export const PACKAGE_GUIDELINES = generateRoute(
  `${RULES_PACKAGES_DETAILS()}/${RULES_AND_PACKAGES_SECTION.PACKAGE_GUIDELINES}`,
)

export const NAMING_CONVENTIONS = generateRoute(
  `${RULES_PACKAGES_DETAILS()}/${RULES_AND_PACKAGES_SECTION.NAMING_CONVENTIONS}`,
)

export const PACKAGE_GUIDELINES_DETAILS = generateRoute(`${PACKAGE_GUIDELINES()}/${PARAM_ENTITY.PACKAGE_GUIDELINE}`)
/****************** TEMPLATE EDITOR STANDALONE *************/

export const TEMPLATE_EDITOR_STANDALONE = generateRoute(`/template-editor/${PARAM_ENTITY.STAGE_TEMPLATE}`)

/****************** PROJECT OVERVIEW *************/

export const PROJECT_OVERVIEW = generateRoute(`/project-overview/${PARAM_ENTITY.PROJECT}`)

/****************** VCP *************/

export const COMPLIANCE = generateRoute('/compliance')
export const COMPLIANCE_AUDIT = generateRoute(`/compliance/audit/${PARAM_ENTITY.AUDIT}`)
export const ORG_COMPLIANCE = generateRoute(`/compliance/organization/${PARAM_ENTITY.ORGANIZATION}`)
export const ORG_COMPLIANCE_AUDIT = generateRoute(
  `/compliance/organization/${PARAM_ENTITY.ORGANIZATION}/audit/${PARAM_ENTITY.AUDIT}`,
)
export const VISUAL_SCOPES_SECTION = {
  AUDITED_VISUALS: 'audited-visuals',
  ASSETS_TO_FIX: 'to-fix',
  SCOPES: 'scopes',
}
export const COMPLIANCE_VISUAL_SCOPES = generateRoute(`/compliance/visual-scopes/${PARAM_ENTITY.AUDIT}`)
export const ORG_COMPLIANCE_VISUAL_SCOPES = generateRoute(
  `/compliance/organization/${PARAM_ENTITY.ORGANIZATION}/visual-scopes/${PARAM_ENTITY.AUDIT}`,
)
export const BRAND_GUIDELINES = generateRoute('/guidelines')

/****************** RELATIVE ROUTE MODALS *************/
export const RELATIVE_BRIEF_DETAILS = `brief/${PARAM_ENTITY.PRODUCT}`
export const RELATIVE_BRIEF_DETAILS_ORDER = `brief-order/${PARAM_ENTITY.BRIEF_ORDER}`
export const RELATIVE_DRAFT_PRODUCT_DETAILS = `brief-draft-product/${PARAM_ENTITY.DRAFT_PRODUCT}`

export const RELATIVE_MINIAPP = `miniapp/${PARAM_ENTITY.ORDER}/task/${PARAM_ENTITY.TASK}`

export const RELATIVE_TASK_DETAILS = `task/${PARAM_ENTITY.TASK}`

export const RELATIVE_AMBIANCE = `ambiance/${PARAM_ENTITY.VISUAL}`

export const RELATIVE_PACKSHOT = `packshot/${PARAM_ENTITY.VISUAL}`

export const RELATIVE_INFINITE = `infinite/${PARAM_ENTITY.DISPLAY}`

export const RELATIVE_GEOMETRY = `geometry/${PARAM_ENTITY.GEOMETRY}`

export const RELATIVE_CREATE_PROJECT = `create-project/${PARAM_ENTITY.PROJECT_TYPE}`

export const RELATIVE_PROJECT_VIEW = `project-view/${PARAM_ENTITY.PROJECT}`

export const RELATIVE_ORDER_PREVIEW = `order-preview/${PARAM_ENTITY.ORDER}`

export const RELATIVE_PRODUCT_PREVIEW = `product-preview/${PARAM_ENTITY.PRODUCT}`

export const RELATIVE_MANAGE_ENDPOINTS = `manage-endpoints`
